import { Component, OnDestroy, OnInit } from '@angular/core';
import { ButtonStyle } from '@core/enumeration';
import { AuthenticationService, IdleService } from '@core/service';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
    selector: 'app-idle',
    templateUrl: './idle.component.html',
    styleUrls: ['./idle.component.scss'],
    standalone: false
})
export class IdleComponent implements OnInit, OnDestroy {
  idleTimer: number;

  private timerStartSubscription: Subscription;
  private timeoutSubscription: Subscription;
  private loginSuccessSubscription: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private idleService: IdleService,
    private confirmationService: ConfirmationService,
  ) {
  }

  ngOnInit() {
    this.idleService.startWatching();

    // Start watching when user idle is starting
    this.timerStartSubscription = this.idleService.onTimerStart()
      .pipe(
        tap(() => this.showModal()),
        map(count => new Date(0, 0, 0).setSeconds(count)),
      )
      .subscribe(timer => this.idleTimer = timer);

    // Start watch when time is up
    this.timeoutSubscription = this.idleService.onTimeout().subscribe(() => this.onLogout());
  }

  ngOnDestroy() {
    if (this.timerStartSubscription) {
      this.timerStartSubscription.unsubscribe();
    }

    if (this.timeoutSubscription) {
      this.timeoutSubscription.unsubscribe();
    }

    if (this.loginSuccessSubscription) {
      this.loginSuccessSubscription.unsubscribe();
    }

    this.idleService.stopWatching();
  }

  showModal(): void {
    this.confirmationService.confirm({
      key: 'logout-warning',
      accept: () => {
        this.onLogout();
      },
      reject: () => {
        this.idleService.stopTimer();
      }
    });
  }

  onLogout() {
    this.idleService.stopWatching();
    this.authenticationService.logout();
  }
}
